import {
  LayoutNarrowTwo,
  LayoutThree,
  LayoutTwo,
  TomatoButton,
} from '../../Layout/CommonStyle'
import RecentJobs from '../../Common/RecentJobs'
import TestList from '../../Common/TestList'
import styled from 'styled-components'
import { UserAll, UserRole } from '../../../models/User'
import { useEffect, useState } from 'react'
import { axiosGet, axiosPost } from '../../Common/Axios'
import { ApiResult } from '../../../models/Enums'
import toast from 'react-hot-toast'

function AdminInstructor() {
  const [instructors, setInstructors] = useState<UserAll[]>([])

  const getInstructors = async () => {
    const result = await axiosGet('/api/user/get_mentors')
    if (result.apiResult !== ApiResult.SUCCESS) {
      console.log('get_mentors error', result.message)
    }
    setInstructors(result.data)
    console.log('result', result)
  }

  useEffect(() => {
    getInstructors()
  }, [])

  const addInstructor = () => {
    const instructor = {
      id: 0,
      userid: '',
      username: '',
      email: '',
      password: '',
      profileImage: '',
      userRole: UserRole.MENTOR,
      groupId: 0,
      enabled: true,
      setting: '{}',
      recentJobs: '[]',
      plainPassword: '',
      isUpdatePassword: false,
    } as UserAll
    setInstructors([...instructors, instructor])
  }

  const deleteInstructor = async (instructor: UserAll) => {
    if (!confirm(`[${instructor.username}] 강사를 삭제하세겠습니까?`)) {
      return
    }
    if (instructor.id !== 0) {
      const payload = {
        id: instructor.id,
      }
      const result = await axiosPost('/api/user/delete_instructor', payload)
      if (result.apiResult !== ApiResult.SUCCESS) {
        console.log('delete_instructor error', result.message)
        toast.error('삭제 실패')
        return
      }
    }
    setInstructors(instructors.filter((i) => i.id !== instructor.id))
    toast.success('삭제 성공')
  }

  const saveInsturctor = async (instructor: UserAll) => {
    const result = await axiosPost('/api/user/save_instructor', instructor)
    if (result.apiResult !== ApiResult.SUCCESS) {
      console.log('save_instructor error', result.message)
      toast.error('저장 실패')
      return
    }

    setInstructors(
      instructors.map((i) =>
        i.id === instructor.id ? { ...instructor, id: result.data } : i
      )
    )
    console.log('result', result)
    toast.success('저장 성공')
  }

  return (
    <Container>
      <div></div>
      <div>
        <Toolbar>
          <TomatoButton onClick={() => addInstructor()}>추가</TomatoButton>
        </Toolbar>
        <List>
          {instructors.map((instructor) => (
            <div key={instructor.id}>
              <input
                type="text"
                placeholder="아이디"
                value={instructor ? instructor.userid : ''}
                onChange={(e) => {
                  if (instructor) {
                    setInstructors(
                      instructors.map((i) =>
                        i.id === instructor.id
                          ? { ...instructor, userid: e.target.value }
                          : i
                      )
                    )
                  }
                }}
              />
              <input
                type="text"
                placeholder="이름"
                value={instructor ? instructor.username : ''}
                onChange={(e) => {
                  if (instructor) {
                    setInstructors(
                      instructors.map((i) =>
                        i.id === instructor.id
                          ? { ...instructor, username: e.target.value }
                          : i
                      )
                    )
                  }
                }}
              />
              <input
                type="text"
                placeholder="비밀번호"
                value={instructor ? instructor.plainPassword : ''}
                onChange={(e) => {
                  if (instructor) {
                    setInstructors(
                      instructors.map((i) =>
                        i.id === instructor.id
                          ? { ...instructor, plainPassword: e.target.value }
                          : i
                      )
                    )
                  }
                }}
              />{' '}
              <input
                type="text"
                placeholder="email"
                value={instructor ? instructor.email : ''}
                onChange={(e) => {
                  if (instructor) {
                    setInstructors(
                      instructors.map((i) =>
                        i.id === instructor.id
                          ? { ...instructor, email: e.target.value }
                          : i
                      )
                    )
                  }
                }}
              />
              <TomatoButton onClick={() => saveInsturctor(instructor)}>
                저장
              </TomatoButton>
              {/* {instructor.id === 0 && ( */}
              <TomatoButton onClick={() => deleteInstructor(instructor)}>
                삭제
              </TomatoButton>
              {/* )} */}
            </div>
          ))}
        </List>
      </div>
    </Container>
  )
}

const Container = styled.div`
  width: 1000px;
  margin: 0 auto;
`
const Toolbar = styled.div`
  padding: 10px 0;
`

const List = styled.div`
  & > div {
    display: grid;
    grid-template-columns: 2fr 1.5fr 1.5fr 2.5fr 1fr 1fr;
    column-gap: 10px;
    grid-template-rows: auto;
    align-items: center;
    /* width: 100px; */
    padding-bottom: 6px;

    & > button {
      min-width: 80px;
      padding: 5px 0px;
      margin-right: 0px;
      margin-top: 0px;
    }
    & > input[type='text'] {
      padding: 12px;
      box-sizing: border-box;
      border: 1px solid #ccc;
    }
  }
`

export default AdminInstructor
